import lzString from 'lz-string';

export const compressLzw = (data: { [key: string]: unknown }) =>
  lzString.compressToEncodedURIComponent(JSON.stringify(data));

export const decompressLzw = (string: string) =>
  JSON.parse(lzString.decompressFromEncodedURIComponent(string));
